import type { FaireProductEntity } from "../../entity_types/product";

export const p_8r5b1tgw: FaireProductEntity = {
  token: "p_8r5b1tgw",
  type: "product",
  name: "Teakwood & Tobacco - 3.5 oz Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/df3fbbf4a41a8c2b527060489f7598eab97facd9a56bb0dc0089489cdf4ff2fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a9ea760b8456d8931233f838a65754104cafdce687630fcd8a9eeb5fb2095af.jpeg",
    "https://cdn.faire.com/fastly/a78745de181d6631954c3214fc690528808dac6c0c7cb3bca105748970fe97b8.jpeg",
    "https://cdn.faire.com/fastly/13db08b780cc750e852f02c52e31fd039a2b76c0bcb7e9650aba1e57d090201c.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/3ec3b40ddf2d4f1d916cabf565664c386c5376775b70151546c6ca3cbe6a81fc.jpeg",
    "https://cdn.faire.com/fastly/3b84c7448c1fd4ba405db55ed07ec4e0f06691eb41a63bb53f5e1efcda2c2e1c.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'The one that started it all. Some call it the boyfriend scent, we call it the O.G. Notes of leather, teak, and orange.\n\nLow-maintenance, flame-free, and always-on scent for entry ways, bathrooms, dorm rooms, and bedrooms.\n\nEach diffuser contains a 3.5 fl oz blend of naturally-derived and man-made fragrance oils in a 4 oz amber apothecary-inspired bottle. Includes a bundle of 9" long naturally-harvested rattan reeds to absorb and slowly release the fragrance. \n\nLasts approximately 3-4 months, flip reeds weekly.',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:53.462Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
